import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import './ClassicExchEvents.scss';
import { Accordion, AccordionDetails, AccordionSummary, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import MarketOddBtn from '../MarketOddBtn/marketOddBtn';
import { RootState } from '../../models/RootState';
import { setExchSelectedSport } from '../../store/exchangeSports/exchangeSportsReducer';
import { fetchSports, listExchEvents, listLiveExchEvents } from '../../store/exchangeSports/exchangeSportsAction';
import Inplay from '../../assets/sports/inplay.gif'
import { sportsIconMap, sportNamesMap, getTranslatedSportName } from '../../constants/sports'
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import ExpandLessSharp from '@mui/icons-material/ExpandLessSharp';
import { dispatch } from '../../store/store';
// import Loader from "../../assets/images/Strike_White_Logo_Transparent_GIF.gif";
import { TopicUrls } from '../../models/EventData';
import { checkStompClientSubscriptions, disconnectToWS, subscribeForMatchOdds } from '../../websockets/webSocket';
import { Loader } from '../../constants/whitelabelEnv';
import { domain } from '../../constants/Branding';
import { UserDetails } from '../../models/UserDetails';
import { useTranslation } from '../../hooks/useTranslation';
type StoreProps = {
    sports: any;
    exchSelectedSport: string;
    setExchSelectedSport: (data: string) => void;
    listExchEvents: (inplay: boolean, sportId: string) => void;
    exchEvents: any;
    listLiveExchEvents: () => void;
    topicUrls?: TopicUrls;
    betFairWSConnected: boolean;
    userDetails: UserDetails;
    showOnlyLive?: boolean;
    maxEventsPerSport?: number;
    compactOdds?: boolean;
    textColorClass?: string;
    dynamicTextColors?: any;
};

export const EmptyOddsBlock = React.memo(() => {
    return (
        <React.Fragment>
            <MarketOddBtn mainValue={null} oddType="back-odd" disable={true} />
            <MarketOddBtn mainValue={null} oddType="lay-odd" disable={true} />
        </React.Fragment>
    );
});

const FEATURED_COMPETITION_ID = '101480';

const isFeaturedLiveEvent = (event: any) =>
    String(event?.competitionId) === FEATURED_COMPETITION_ID && event?.status === 'IN_PLAY';

const sortEventsWithFeaturedLiveFirst = (events: Record<string, any> | undefined) => {
    const list = Object.values(events || {});
    return [...list].sort((a, b) => {
        const aPinned = isFeaturedLiveEvent(a);
        const bPinned = isFeaturedLiveEvent(b);
        if (aPinned && !bPinned) return -1;
        if (!aPinned && bPinned) return 1;
        return 0;
    });
};

const ClassicExchEvents: React.FC<StoreProps> = (props) => {
    const { t } = useTranslation();
    const { sports, exchSelectedSport, setExchSelectedSport, listExchEvents, exchEvents, listLiveExchEvents, topicUrls, betFairWSConnected, userDetails, showOnlyLive = false, maxEventsPerSport, compactOdds = false, textColorClass: propTextColorClass = "", dynamicTextColors } = props;
    
    // Get dynamic text color classes from Redux instead of calling function
    const defaultPageTextColorClass = dynamicTextColors?.pageTextColorClass || '';
    const accordionHeaderTextColorClass = dynamicTextColors?.accordionHeaderTextColorClass || '';
    const tableRowTextColorClass = dynamicTextColors?.tableTextColorClass || '';
    const pageTextColorClass = propTextColorClass || defaultPageTextColorClass;
    const LIVE = "LIVE";
    const teamTypes = compactOdds ? [0, 1] : [0, 2, 1];
    const customGroupOrder = ["LIVE", "LIVE-4", "LIVE-1", "LIVE-2", "UPCOMING"];
    const customOrder = ["4", "1", "2"];
    const [sortedEvents, setSortedEvents] = useState<any>();
    const [sortedSports, setSortedSports] = useState<any>();
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(false);

    const getOdds = (eventData: any, teamIndex: number) => {
        if (!eventData?.markets?.matchOdds?.[0]?.runners?.[teamIndex]) {
            return null;
        }

        const runner = eventData?.markets?.matchOdds?.[0]?.runners?.[teamIndex];
        return [
            {
                type: 'back-odd',
                price: runner?.backPrices?.[0]?.price,
                size: runner?.backPrices?.[0]?.size,
                outcomeId: runner?.runnerId,
                outcomeName: runner?.runnerName,
            },
            {
                type: 'lay-odd',
                price: runner?.layPrices?.[0]?.price,
                size: runner?.layPrices?.[0]?.size,
                outcomeId: runner?.runnerId,
                outcomeName: runner?.runnerName,
            },
        ];
    };

    useEffect(() => {
        const init = async () => {
            if (sports && sports.length > 0) {
                const sortedSports = [...sports].sort((a, b) => {
                    const indexA = customOrder.indexOf(a.sportId?.toString());
                    const indexB = customOrder.indexOf(b.sportId?.toString());

                    if (indexA === -1 && indexB === -1) return 0;
                    if (indexA === -1) return 1;
                    if (indexB === -1) return -1;

                    return indexA - indexB;
                });
                setSortedSports(sortedSports);
                if (!exchSelectedSport) {
                    setExchSelectedSport(LIVE);
                }
            } else {
                setLoading(true);
                await dispatch(fetchSports(userDetails?.exchangeProvider));
                setLoading(false);
            }
        };
        init();

    }, [sports]);

    useEffect(() => {
        if (showOnlyLive) {
            listLiveExchEvents();
        } else if (exchSelectedSport === LIVE) {
            listLiveExchEvents();
        } else if (exchSelectedSport) {
            listExchEvents(true, exchSelectedSport);
            listExchEvents(false, exchSelectedSport);
        }
    }, [exchSelectedSport, showOnlyLive]);

    useEffect(() => {
        if (topicUrls?.matchOddsBaseUrl) {
            const baseUrlsPayload = {
                matchOddsBaseUrl: topicUrls?.matchOddsBaseUrl,
                bookMakerAndFancyBaseUrl: null,
                premiumBaseUrl: null,
            };
            checkStompClientSubscriptions(baseUrlsPayload);
        }
    }, [topicUrls]);

    useEffect(() => {
        return () => {
            disconnectToWS();
        };
    }, []);

    useEffect(() => {
        if (!betFairWSConnected || !topicUrls?.matchOddsTopic) return;

        const newSubscriptions = new Set();
        Object.entries(exchEvents || {}).forEach(([sportKey, eventMap]) => {
            Object.values(eventMap || {}).forEach((event: any) => {
                const shouldSubscribe =
                    event?.status === 'IN_PLAY' &&
                    event?.markets?.matchOddsProvider === 'BetFair' &&
                    !newSubscriptions.has(event.eventId) &&
                    event?.markets?.matchOdds?.length > 0 &&
                    event?.markets?.matchOdds?.[0]?.marketId;

                if (shouldSubscribe) {
                    newSubscriptions.add(event.eventId);
                    subscribeForMatchOdds(
                        topicUrls.matchOddsTopic,
                        sportKey,
                        event?.eventId,
                        event?.markets?.matchOdds?.[0]?.marketId
                    );
                }
            });
        });
    }, [exchEvents, betFairWSConnected]);

    useEffect(() => {
        let validEntries = Object.entries(exchEvents).filter(
            ([, eventMap]) => eventMap && typeof eventMap === 'object' && Object.keys(eventMap).length > 0
        );

        if (showOnlyLive) {
            validEntries = validEntries.filter(([key]) => key.startsWith('LIVE-'));
        }

        const sortedEntries = validEntries.sort(([keyA], [keyB]) => {
            const indexA = customGroupOrder.indexOf(keyA);
            const indexB = customGroupOrder.indexOf(keyB);

            if (indexA !== -1 && indexB !== -1) return indexA - indexB;
            if (indexA !== -1) return -1;
            if (indexB !== -1) return 1;

            return keyA.localeCompare(keyB);
        });

        const featuredGroupIndex = sortedEntries.findIndex(([, eventMap]) =>
            Object.values(eventMap || {}).some((e: any) => isFeaturedLiveEvent(e))
        );
        if (featuredGroupIndex > 0) {
            const [featuredEntry] = sortedEntries.splice(featuredGroupIndex, 1);
            sortedEntries.unshift(featuredEntry);
        }

        setSortedEvents(sortedEntries);
    }, [exchEvents, showOnlyLive]);

    const handleEventClick = (eventDto: any) => {
        console.log('[ClassicExchEvents] Event clicked:', {
            eventDto,
            sportId: eventDto?.sportId,
            competitionId: eventDto?.competitionId,
            eventId: eventDto?.eventId,
            url: `/markets/${btoa(eventDto?.sportId + "|" + eventDto?.competitionId + "|" + eventDto?.eventId)}`
        });
        navigate(`/markets/${btoa(eventDto?.sportId + "|" + eventDto?.competitionId + "|" + eventDto?.eventId)}`);
    };

    return (
        <div className={pageTextColorClass}>
            {
                loading ? (
                    <div className="home-loading">
                        <img src={Loader(domain)} style={{ height: '10rem' }} />
                    </div>

                ) : (
                    <>
                    {!showOnlyLive && (
                        <div className={`exch-sports-tabs-ctn ${pageTextColorClass}`}>
                            <div className="exch-sports-tabs">
                                <div className="exch-sport-tabs">
                                    <button
                                        className={`exch-tab ${exchSelectedSport === LIVE
                                            ? 'exch-selected-tab'
                                            : ''
                                            }`}
                                        onClick={() => {
                                            setExchSelectedSport(LIVE);
                                        }}
                                    >
                                        <img src={Inplay} className="exch-sub-header-icons" style={{ margin: "-6px 0px 0px 4px", height: "25px", width: "50px" }} />

                                    </button>
                                    {sortedSports?.map(
                                        (sport: any) =>
                                            <button
                                                key={sport?.sportId}
                                                className={`exch-tab ${exchSelectedSport === sport?.sportId
                                                    ? 'exch-selected-tab'
                                                    : ''
                                                    }`}
                                                onClick={() => {
                                                    setExchSelectedSport(sport?.sportId);
                                                }}
                                            >
                                                <img src={sportsIconMap[sport?.sportId]} className="exch-sub-header-icons" />
                                                {getTranslatedSportName(sport?.sportId?.toString(), t) || sport?.sportName}
                                            </button>
                                    )}
                                </div>
                            </div>
                        </div>
                        )}

                        <div className="exch-events-table-ctn">
                            {sortedEvents?.length ? (
                                (sortedEvents ?? [])?.map(([sportId, events]: [string, any[]], sportIndex: number) => (
                                    <>
                                        <Accordion
                                            className={`exch-eventtype-accordion ${accordionHeaderTextColorClass}`}
                                            defaultExpanded={compactOdds ? sportIndex === 0 : true}
                                            key={sportId}
                                        >
                                            <AccordionSummary
                                                expandIcon={
                                                    <ExpandLessSharp className="expand-icon" />
                                                }
                                                aria-controls="panel1a-content"
                                            >
                                                <TableRow
                                                    className="acc-head"
                                                >
                                                    <TableCell
                                                        colSpan={3}
                                                        className="acc-cell"
                                                    >
                                                        <div className={`exch-icon-and-name ${accordionHeaderTextColorClass}`}>
                                                            <img src={sportsIconMap[sportId?.includes("-") ? sportId?.split("-")[1] : sportId]} />
                                                            <div className="exch-event-name">
                                                                {
                                                                    (() => {
                                                                        const key = sportId.includes("-") ? sportId.split("-")[1] : sportId;
                                                                        if (key === "LIVE") return t("sports.liveTitle");
                                                                        if (key === "UPCOMING") return t("sports.upcomingTitle");
                                                                        const translated = getTranslatedSportName(key, t);
                                                                        return translated || sportNamesMap[key] || '';
                                                                    })()
                                                                }{' '}
                                                            </div>
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            </AccordionSummary>
                                            <AccordionDetails className="exch-events-tbl-container">
                                                <div className="exch-events-table-content table-ctn">
                                                    <TableContainer component={Paper}>
                                                        <Table className="exch-events-table exch-inplay-table">
                                                            <TableBody>
                                                                {(maxEventsPerSport
                                                                    ? sortEventsWithFeaturedLiveFirst(events).slice(0, maxEventsPerSport)
                                                                    : sortEventsWithFeaturedLiveFirst(events)
                                                                ).map((event: any, idx: any) => (
                                                                    <TableRow
                                                                        key={event?.eventId ?? `${sportId}-${idx}`}
                                                                        onClick={() =>
                                                                            handleEventClick(event)
                                                                        }
                                                                        className={`exch-bgc-white ${tableRowTextColorClass}`}
                                                                    >
                                                                        <TableCell
                                                                            className={`exch-teams-cell exch-et-b-c ${tableRowTextColorClass}`}
                                                                            colSpan={8}
                                                                        >
                                                                            <div
                                                                                className={`all-markets-nav-link ${compactOdds ? 'compact-row' : ''} ${tableRowTextColorClass}`}
                                                                                key={idx + 'all-markets-link'}
                                                                            >
                                                                                {compactOdds ? (
                                                                                    /* Compact single-row layout */
                                                                                    <>
                                                                                        <div className="compact-event-info">
                                                                                            <div className="compact-event-name-row">
                                                                                                <div className={`compact-event-name ${tableRowTextColorClass}`}>{event?.eventName}</div>
                                                                                                <div className="compact-markets-inline">
                                                                                                    {event?.markets?.matchOdds?.length > 0 && <span className={`market-badge-sm ${tableRowTextColorClass}`}>MO</span>}
                                                                                                    {event?.markets?.bookmakers?.length > 0 && <span className={`market-badge-sm ${tableRowTextColorClass}`}>BM</span>}
                                                                                                    {event?.markets?.fancyMarkets?.length > 0 && <span className={`market-badge-sm ${tableRowTextColorClass}`}>F</span>}
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="compact-event-meta">
                                                                                                <span className={`exch-date ${tableRowTextColorClass}`}>
                                                                                                    {moment(event?.openDate).format('DD/MM , hh:mm A')}
                                                                                                </span>
                                                                                                {event?.status == 'IN_PLAY' && (
                                                                                                    <img className="exch-live-img-display" src={Inplay} />
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="compact-odds-row">
                                                                                            {teamTypes.map((teamType, index) => (
                                                                                                <div className="compact-odds-block" key={index}>
                                                                                                    {event?.markets?.matchOdds ? (
                                                                                                        getOdds(event, teamType) ? (
                                                                                                            getOdds(event, teamType)?.map((odd: any, oddIdx: any) => (
                                                                                                                <MarketOddBtn
                                                                                                                    key={oddIdx}
                                                                                                                    mainValue={odd?.price}
                                                                                                                    oddType={odd?.type}
                                                                                                                    disable={event?.markets?.matchOdds?.[0]?.status?.toLowerCase().includes('suspended')}
                                                                                                                    valueType="matchOdds"
                                                                                                                />
                                                                                                            ))
                                                                                                        ) : (
                                                                                                            <EmptyOddsBlock />
                                                                                                        )
                                                                                                    ) : (
                                                                                                        <EmptyOddsBlock />
                                                                                                    )}
                                                                                                </div>
                                                                                            ))}
                                                                                        </div>
                                                                                    </>
                                                                                ) : (
                                                                                    /* Original multi-row layout */
                                                                                    <>
                                                                                <div className="exch-team-name">
                                                                                    <div className="exch-home-away-team">
                                                                                        <div className={`exch-team-names ${tableRowTextColorClass}`}>{event?.eventName}</div>

                                                                                        <div className={`exch-team-names exch-flex-team ${tableRowTextColorClass}`}>
                                                                                            <span className={`exch-date ${tableRowTextColorClass}`}>
                                                                                                {'(' + moment(event?.openDate).format('DD/MM/YY , hh:mm A') + ')'}
                                                                                            </span>
                                                                                            {event?.status == 'IN_PLAY' && (
                                                                                                <img
                                                                                                    className={'exch-live-img-display'}
                                                                                                    src={Inplay}
                                                                                                />
                                                                                            )}
                                                                                            {event?.status === 'UPCOMING' && (
                                                                                                <div className="exch-upcoming-badge">{t("sports.upcoming")}</div>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="enabled-markets">

                                                                                        {event?.catId === 'SR VIRTUAL' &&
                                                                                            <div className={`market-enabled-inner ${tableRowTextColorClass}`}>
                                                                                                {'V'}
                                                                                            </div>}

                                                                                        {event?.premiumEnabled && event?.catId !== 'SR VIRTUAL' &&
                                                                                            <div className={`market-enabled-inner ${tableRowTextColorClass}`}>
                                                                                                {'P'}
                                                                                            </div>}
                                                                                        {event?.markets?.matchOdds?.length > 0 &&
                                                                                            <div className={`market-enabled-inner ${tableRowTextColorClass}`}>
                                                                                                {'MO'}
                                                                                            </div>}
                                                                                        {event?.markets?.bookmakers?.length > 0 &&
                                                                                            <div className={`market-enabled-inner ${tableRowTextColorClass}`}>
                                                                                                {'BM'}
                                                                                            </div>}
                                                                                        {event?.markets?.fancyMarkets?.length > 0 &&
                                                                                            <div className={`market-enabled-inner ${tableRowTextColorClass}`}>
                                                                                                {'F'}
                                                                                            </div>}
                                                                                    </div>
                                                                                </div>

                                                                                {(
                                                                                    <div className="mob-odds-row new-odds-row">
                                                                                        {teamTypes.map((teamType, index) => (
                                                                                            <div
                                                                                                className="mob-odds-block"
                                                                                                key={index}
                                                                                            >
                                                                                                <div className="mob-exchange-btn-odd-row">
                                                                                                    {event?.markets?.matchOdds ? (
                                                                                                        getOdds(event, teamType) ? (
                                                                                                            <>
                                                                                                                {getOdds(
                                                                                                                    event,
                                                                                                                    teamType
                                                                                                                )?.map((odd: any, index: any) => (
                                                                                                                    <MarketOddBtn
                                                                                                                        key={index}
                                                                                                                        mainValue={odd.price}
                                                                                                                        subValue={odd.size}
                                                                                                                        oddType={odd.type}
                                                                                                                        disable={event?.markets?.matchOdds?.[0]?.status
                                                                                                                            .toLowerCase()
                                                                                                                            .includes(
                                                                                                                                'suspended'
                                                                                                                            )}
                                                                                                                        valueType={
                                                                                                                            'matchOdds'
                                                                                                                        }
                                                                                                                        showSubValueinKformat={
                                                                                                                            true
                                                                                                                        }
                                                                                                                    />
                                                                                                                ))}
                                                                                                            </>
                                                                                                        ) : (
                                                                                                            <EmptyOddsBlock />
                                                                                                        )
                                                                                                    ) : (
                                                                                                        <EmptyOddsBlock />
                                                                                                    )}
                                                                                                </div>
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                )}
                                                                                    </>
                                                                                )}
                                                                            </div>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>
                                    </>
                                ))
                            ) :
                                <div className={`events-table-msg-text ${tableRowTextColorClass}`}>
                                    {t("sports.messages.noEvents")}
                                </div>
                            }
                        </div>
                    </>
                )
            }
        </div>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        sports: state.exchangeSports.exchSports,
        exchSelectedSport: state.exchangeSports.exchSelectedSport,
        exchEvents: state.exchangeSports.exchEvents,
        topicUrls: state?.exchangeSports?.topicUrls,
        betFairWSConnected: state?.exchangeSports?.betFairWSConnected,
        userDetails: state.userDetails.userDetails,
        dynamicTextColors: state.userDetails?.dynamicTextColors,
    };
};

const mapDispatchToProps = (dispatch: Function) => {
    return {
        setExchSelectedSport: (data: string) => dispatch(setExchSelectedSport(data)),
        listExchEvents: (inplay: boolean, sportId: string) => dispatch(listExchEvents(inplay, sportId)),
        listLiveExchEvents: () => dispatch(listLiveExchEvents()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClassicExchEvents);
